export default __webpack_public_path__ + "static/media/cont9.26308906.png";